export default "__VITE_ASSET__de17f0c8__"